// Voidgunner mutable run-state. Every value that changes during a run lives here on `S`,
// so it can be read/written across modules (an imported `let` can't be reassigned by an importer).
// Constants & data (BAL, WEAPONS, ITEMS, …) are NOT here — they stay plain exports.
//
// Typed as Record<string, any> during the modularization so `S.anything` stays valid;
// Phase 2 will replace this with a real typedef enumerating the fields.

/** @type {Record<string, any>} */
export const S = {};
